<template>
  <div class="bread-crumb">
    <div class="bread-crumb-box">
      <div
        v-for="(bread,index) in breadList"
        :key="bread.id"
        class="bread-crumb-item"
        @click.stop="toBread(bread)"
      >
        <el-link target="_blank" :class="[{ islast: breadList.length === index + 1 },'bread-item-btn']">
          {{ bread.clabel }}
        </el-link>
        <i v-show="breadList.length !== index + 1" class="el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    breadList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    toBread(data) {
      this.$emit('changeBread', data);
    }
  }
};
</script>

<style lang="scss" scoped>
.bread-crumb {
  width: 100%;
  height: 40px;
  overflow-x: scroll;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #3584d9;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }

  .bread-crumb-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #f6f7f9;
    //flex-flow: row nowrap;
    .bread-crumb-item {
      height: 30px;
      margin: 0 5px;
      display: flex;
      align-items: center;
      font-size: 16px;
      flex-shrink: 0;
      //flex: 1;
      .bread-item-btn {
        height: 100%;
        line-height: 30px;
        color: #3584d9;
        margin-right: 10px;
      }

      .islast {
        color: #abadaf !important;
      }
    }
  }
}
</style>
